import getCalendarConfig from './getCalendarConfig';
import isWorkDay from './isWorkDay';
import isWorkStartTime from './isWorkStartTime';
import isWorkEndTime from './isWorkEndTime';
import setWorkTime from './setWorkTime';
import setCustomWorkTime from './setCustomWorkTime';

export { ALL_DAYS } from './setWorkTime';
export default {
  getCalendarConfig,
  isWorkDay,
  isWorkStartTime,
  isWorkEndTime,
  setWorkTime,
  setCustomWorkTime,
};
